import { KeyValue } from '@angular/common';
import { Injectable } from '@angular/core';
import { FilterStorageType, FilterStorage } from '../models/filters.model';
import { CalibrationInformation, CalibrationResponse } from 'app/api/models';
import { sortOnProperty } from 'app/app.component';

export class DatedCalibrationResponse {
  calibration?: CalibrationInformation;
  loadcellId?: number;
  date?: Date;
}

@Injectable({
  providedIn: 'root',
})
export class LocalStoreService {
  private ls = window.localStorage;

  public readonly CALIBRATION_DUMP_KEY = 'NEXUS_CALIBRATION_DATA';

  constructor() {}

  public setItem(key, value) {
    value = JSON.stringify(value);
    this.ls.setItem(key, value);
    return true;
  }

  public getItem(key) {
    const value = this.ls.getItem(key);
    try {
      return JSON.parse(value);
    } catch (e) {
      return null;
    }
  }

  public clear() {
    this.ls.clear();
  }


  public getFilters(key: string) {
    return JSON.parse(this.getItem(key));
  }

  public getFiltersValue(filterStorageType: FilterStorageType, filters: FilterStorage) {
    if (!filters?.filters) return null;

    return filters?.filters?.find((x) => x.key == filterStorageType)
      ?.value;
  }

  public addFilters(key: string, filters: FilterStorage) {
    var filtersJson = JSON.stringify(filters);
    this.setItem(key, filtersJson);
  }

  public updateFilters(
    pageKey: string,
    filter: KeyValue<FilterStorageType, string>,
    filters: FilterStorage
  ) {
    this.getFilters(pageKey);

    if (!filters) {
      // add filter storage
      this.addFilters(pageKey, { filters: [filter] });
    } else {
      var existingFilter = filters?.filters.find(
        (x) => x.key == filter?.key
      );

      if (!existingFilter) {
        // add filter keypair
        filters?.filters?.push(filter);
      } else {
        // update the existing value
        existingFilter.value = filter?.value;
      }

      this.setItem(pageKey, JSON.stringify(filters));
    }
  }

  //calibration dumps
  public storeCalibration(calibration: DatedCalibrationResponse): void {
    calibration.date = new Date();
    console.log("storing calibration", calibration);

    var calibrations = this.getCalibrations();

    var calibI = calibrations.findIndex(x => x.calibration.calibrationId == calibration.calibration.calibrationId);

    if(calibI > -1)
      calibrations[calibI] = calibration;
    else
      calibrations.push(calibration);

    this.setItem(this.CALIBRATION_DUMP_KEY, calibrations);
  }

  public getCalibrations(): DatedCalibrationResponse[] {
    var calibrations = this.getItem(this.CALIBRATION_DUMP_KEY) ?? [];
    return sortOnProperty(calibrations, 'date', false);
  }

  public getStoredCalibration(calibrationId: number) {
    var calibrations = this.getCalibrations();
    return calibrations.find(x => x.calibration.calibrationId == calibrationId) ?? null;
  }

  public clearCalibrationsForId(calibrationId: number): void {
    var calibrations = this.getCalibrations();

    calibrations = calibrations.filter(x => x.calibration.calibrationId != calibrationId);

    this.setItem(this.CALIBRATION_DUMP_KEY, calibrations);
  }
}
